import { LocalizedText, useUrlSyncedTableState } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    EnumFilterType,
    Table,
    TableActiveColumnFilters,
    TableHeader,
    TableProvider,
    useFullRowSelection,
} from '@optimus-web/core';
import {
    GuidFilterType,
    PortfolioRateOverview,
    PortfolioRateOverviewFilters,
    PortfolioRateType,
} from '@mews-commander/data-access';
import { BulkActions } from '../../Rates/BulkActions';
import { useRates } from '../../../../queries';
import { columns } from './ratesTableMapping';

export const RatesTabContent = ({ rateGroupId }: { rateGroupId?: string }) => {
    const [tableState, setTableState] = useUrlSyncedTableState<PortfolioRateOverview, PortfolioRateOverviewFilters>({
        columns,
        pageSize: 50,
    });

    const rateFilters: PortfolioRateOverviewFilters = {
        type: [{ filterType: EnumFilterType.In, value: [PortfolioRateType.Private, PortfolioRateType.Public] }],
        ...(rateGroupId ? { rateGroupId: [{ filterType: GuidFilterType.Equals, value: rateGroupId }] } : null),
    };
    const { data, isFetching } = useRates(tableState, rateFilters);
    const { selectedRowsData, rowSelection, setRowSelection, resetRowSelection } = useFullRowSelection(data?.data);

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <TableHeader title={<LocalizedText textKey={TextKey.RatePlural} />} subTitle={data?.totalRowCount || '0'} />
            <TableActiveColumnFilters />
            <BulkActions selectedRows={selectedRowsData} resetRowSelection={resetRowSelection} />
            <Table
                uniqueRowId="id"
                fixedFirstColumn
                data={data?.data ?? []}
                amountOfRows={data?.totalRowCount ?? 0}
                loading={isFetching}
                rowSelection={{
                    rowSelection,
                    onRowSelectionChange: setRowSelection,
                }}
            />
        </TableProvider>
    );
};
